/**
 * Shared upstream error contract for CMS/facade fetchers.
 *
 * Detail fetchers must only return `null` (which pages turn into
 * `notFound()`) when the upstream explicitly says the content does not
 * exist: an HTTP 404 or a 200 response with an empty `data` array.
 * Every other failure — 5xx, non-404 4xx (misconfiguration), network or
 * parse errors — must throw so an ISR background revalidation fails and
 * Next.js keeps serving the last good page instead of caching a 404.
 */
export const upstreamNotFound = (res: Response): boolean => res.status === 404;

export function assertUpstreamOk(res: Response, context: string): void {
  if (!res.ok) {
    throw new Error(
      `${context} failed: ${res.status} ${res.statusText || 'Unknown error'}`,
    );
  }
}
